import constant from "@/utils/constant";

const generatePermissionModule = (suffixModuleName, constantModuleName) => ({
	[`mixinIsCanView${suffixModuleName}`]() {
		return this.$store.getters["auth/hasPermission"](constant.PERMISSION[constantModuleName].CAN_VIEW);
	},
	[`mixinIsCanCreate${suffixModuleName}`]() {
		return this.$store.getters["auth/hasPermission"](constant.PERMISSION[constantModuleName].CREATE);
	},
	[`mixinIsCanUpdate${suffixModuleName}`]() {
		return this.$store.getters["auth/hasPermission"](constant.PERMISSION[constantModuleName].UPDATE);
	},
	[`mixinIsCanDelete${suffixModuleName}`]() {
		return this.$store.getters["auth/hasPermission"](constant.PERMISSION[constantModuleName].DELETE);
	},
	[`mixinIsCanViewAll${suffixModuleName}`]() {
		return this.$store.getters["auth/hasPermission"](constant.PERMISSION[constantModuleName].VIEW_ALL);
	}
});

export const kpiPermissions = generatePermissionModule("KPI", "KPI");
export const titlePermissions = generatePermissionModule("Title", "TITLE");
export const todoPermissions = generatePermissionModule("Todo", "TODOLIST");
export const devicePermissions = generatePermissionModule("Device", "DEVICE");
export const requestPermissions = generatePermissionModule("Request", "REQUEST");
export const employeePermissions = generatePermissionModule("Employee", "EMPLOYEE");
export const categoryPermissions = generatePermissionModule("Category", "CATEGORY");
export const customerPermissions = generatePermissionModule("Customer", "CUSTOMER");
export const userRolePermissions = generatePermissionModule("UserRole", "USER_ROLE");
export const inventoryPermissions = generatePermissionModule("Inventory", "INVENTORY");
export const accessoryPermissions = generatePermissionModule("Accessory", "ACCESSORY");
export const departmentPermissions = generatePermissionModule("Department", "DEPARTMENT");
export const reportFormPermissions = generatePermissionModule("ReportForm", "REPORT_FORM");
export const requestTypePermissions = generatePermissionModule("RequestType", "REQUEST_TYPE");
export const backendUserPermissions = generatePermissionModule("BackendUser", "BACKEND_USER");
export const pipelinePermissions = generatePermissionModule("Pipeline", "PIPELINE");
export const productPermissions = generatePermissionModule("Product", "PRODUCT");
export const alarmPermissions = generatePermissionModule("Alarm", "ALARM");
export const contractPermissions = generatePermissionModule("Contract", "CONTRACT");
export const economicContractPermissions = generatePermissionModule("EconomicContract", "ECONOMIC_CONTRACT");
export const stockCardPermissions = generatePermissionModule("StockCard", "STOCK_CARD");
export const productStockPermissions = generatePermissionModule("ProductStock", "PRODUCT_STOCK");

export const getUserPermissions = (permissionModule = {}) => ({
	computed: permissionModule
});
